import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import { useMyStore } from "src/components/main/mainStore";
import Resize from "src/components/common/resize";
import {
    weekDays, 
    getDateTime, 
    getDateEndFromWeekNum, 
    getDatefromWeekNum, 
    getDateEndFromWeekNum2, 
    MyDate, 
    myAxios, 
    MyFormData, 
    isDevMode, 
    weeknum, 
    buildWeekNumArray, 
    getTimeStamp, 
    standbyStartDate as startDate, 
    outsideDailydefaultEmptyData as defaultEmptyData,
    appTitle, 
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function CheckIn({ tabTitle }){
    const timeValid1 = (week, i) => getDateTime(week, i, 10, 30) > new Date();
    const timeValid2 = (week, i) => getDateTime(week, i, 13, 30) > new Date();
    const history = useHistory();
    const path = history.location.pathname;
    const path1 = path.split("/")[1];
    const path2 = path.split("/")[2];
    //--------------------------------------------------------------------------------------------
    const user = useMyStore(state => state.user);
    const [weeks] = useState(buildWeekNumArray(startDate).filter(week => (
        (getDateTime(week, 7, 0, 0) > (new Date(user.hireDate.replace(/-/g, "/")))) && 
        (user.quitDate?(getDateTime(week, 0, 0, 0) <= (new Date(user.quitDate.replace(/-/g, "/")))):true)
    )).reverse());
    const [week, setWeek] = useState(() => weeks.includes(path2)?path2:(
        weeks.includes(weeknum((new MyDate()).s()))?weeknum((new MyDate()).s()):
        (weeks.length?weeks[0]:"")
    ));
    //--------------------------------------------------------------------------------------------
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const forms = useMyStore(state => state.outsideserviceIndividualDailyForms);
    const setForms = useMyStore(state => state.setOutsideserviceIndividualDailyForms);
    const form = forms[week] ?? {};
    //--------------------------------------------------------------------------------------------
    const [updateDateTime, setUpdateDateTime] = useState({
        "Forms": forms.updatedAt === null?getTimeStamp():forms.updatedAt
    });
    //--------------------------------------------------------------------------------------------
    const [showLoading, setShowLoading] = useState(false);
    const [isEdittingContent, setIsEdittingContent] = useState(false);
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        if(isDevMode) console.log("useEffect");
        let isMounted = true;
        const getData = async () => {
            //-------------------------------------
            const formData = new MyFormData();
            formData.append("week", week);
            formData.append("action", "Read");
            setShowLoading(true);
            const res = await myAxios("outside/daily/daily.php", formData);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            //-------------------------------------
            setForms(week, JSON.parse(res.data[week] || defaultEmptyData), updateDateTime["Forms"]);
        }
        if(!forms[week] || (updateDateTime["Forms"] !== forms.updatedAt)) getData();
        return () => {isMounted = false;}
    },[history, updateDateTime["Forms"], week])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //--------------------------------------------------------------------------------------------
    return(
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    Check-In
                    <span
                        data-toggle = "tooltip"
                        title = {`Refreshed on ${Object.values(updateDateTime)[0]}.`}
                        className = "btn btn-primary py-1 ml-4"
                        onClick = {() => {
                            const timeStamp = getTimeStamp();
                            setUpdateDateTime(Object.fromEntries(Object.keys(updateDateTime).map(key => [key, timeStamp])));
                        }}
                    >
                        ↻
                    </span>
                </span>
                <span></span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "week" className = "mb-0">
                        Week:
                    </label>
                    <select
                        id = "week"
                        className = "form-control w-auto ml-2"
                        value = {week}
                        onChange = {e => {
                            setIsEdittingContent(false);
                            setWeek(e.currentTarget.value);
                            history.push(`/${path1}/${e.currentTarget.value}`);                   
                        }}
                    >
                        {weeks.map((k, key) => <option key = {key} value = {k}>{getDateEndFromWeekNum(k)}</option>)}
                    </select>
                </span>
            </div>
            <div>
                <div className = "cssContent pb10">
                    {showLoading?<div className = "cssLoading">Loading...</div>:
                    JSON.stringify(form) === "{}"?<div className = "cssLoading">Empty</div>:
                    <form
                        className = "p-3"
                        onSubmit = {async e => {
                            e.preventDefault();
                            const formData = new MyFormData();
                            formData.append("currentWeek", week);
                            formData.append("data", JSON.stringify(form));
                            //----------------------------------------------------------------
                            setShowLoader(true);
                            const res = await myAxios("outside/daily/daily.php", formData);
                            setShowLoader(false);
                            if(!res) return;
                            //----------------------------------------------------------------
                            setUpdateDateTime({...updateDateTime, "Forms": getTimeStamp()});
                            setIsEdittingContent(false);
                        }}
                    >
                        <div className = "h3 text-danger font-weight-bold">{getDateEndFromWeekNum(week)}</div>
                        <li>
                            <strong><u>Instructions</u></strong>
                            <ul>
                                <li>The purpose of this check-in is to make sure that you are safe. Please do not check both boxes at once. The point is to check them out throughout the day. First cutoff is at 10:30am and the second cutoff is at 1:30pm. If you will be working overtime, please inform us with the second check in and let us know what your expected end time will be.</li>
                                <li>We know this can be tedious, but we do not want anything to happen to you. It's all about <strong><u>your</u></strong> safety! Remember YNY!!</li>
                                <li>Thank you!</li>
                            </ul>
                        </li>
                        <strong><u>Current Danger: HEAT</u></strong>
                        <p><em>Extreme heat causes more deaths each year than hurricanes, lightning, tornadoes, earthquakes, and flood COMBINED.</em></p>
                        <li>
                            <strong><u>Who is at risk</u></strong>
                            <ul>
                                <li>Adults over 65</li>
                                <li>Children under 4</li>
                                <li>Those with existing medical problems such as heart disease.</li>
                            </ul>
                        </li>
                        <li>
                            <strong><u>What to do</u></strong>
                            <ul>
                                <li>Stay Cool</li>
                                <ul>
                                    <li>Find air conditioning</li>
                                    <li>Avoid direct sunlight</li>
                                    <li>Weart lightweight, light-colored clothes</li>
                                    <li>Use a fan as a primary cooling device</li>
                                    <li>Take cool showers</li>
                                    <li>Use Ice Packs on your body in no more than 15 min increments, if possible, and always use a towel or cloth between your skin and the Ice Pack.</li>
                                </ul>
                                <li>Stay Hydrated</li>
                                <ul>
                                    <li>Drink more water than usual</li>
                                    <li>Start hydrating the night before</li>
                                    <li>Don't wait until you are thirsty to drink more fluids</li>
                                    <li>Avoid alcohol and liquids containing high sugar content</li>
                                </ul>
                            </ul>
                        </li>
                        <li>
                            <strong><u>What to look for</u></strong>
                            <ul>
                                <li>Heat Exhaustion</li>
                                <ul>
                                    <li>Dizziness / Light-headed</li>
                                    <li>Heavy sweating & thirst</li>
                                    <li>Nausea / Vomiting</li>
                                    <li>Muscle Cramps</li>
                                    <li>Weakness</li>
                                </ul>
                                <li>Heat Stroke</li>
                                <ul>
                                    <li>Elevated temperature</li>
                                    <li>Confusion/ strange behavior</li>
                                    <li>Difficulty breathing</li>
                                    <li>Persistent vomiting</li>
                                    <li>Loss of consciousness</li>
                                </ul>
                            </ul>
                        </li>
                        <div className = "row">
                            {weekDays.map((weekday, i) => 
                            <div className = "col-lg" key = {i}>
                                <div className = "mt-2 h4 text-secondary">{weekday} ({getDatefromWeekNum(week, i)}) </div>
                                <div className = "mt-2">
                                    {!timeValid1(week, i) && !form.form[i].unlock?
                                    <span className = "badge badge-primary">past</span>
                                    :null}
                                </div>
                                <div className = "mt-2">
                                    <input id = {`acknowledge ${i} 1`} className = "cssCheckBox mt-2" type = "checkbox" disabled = {!(isEdittingContent && (timeValid1(week, i)) || form.form[i].unlock)} 
                                    checked = {form.form[i].morning} onChange = {e => {
                                        setForms(week, {
                                            ...form, 
                                            form: form.form.map(
                                                (
                                                    (ff, weekday) => weekday === i?
                                                    {
                                                        ...ff, 
                                                        morning: e.currentTarget.checked
                                                    }:ff
                                                )
                                            )
                                        });
                                    }}/><label htmlFor = {`acknowledge ${i} 1`} className = "d-inline mb-0 ml-2">I acknowledge that I understand the dangers of high temperatures and that I am currently safe.</label>
                                </div>
                                <div className = "mt-2">
                                    {!timeValid2(week, i) && !form.form[i].unlock?
                                    <span className = "badge badge-primary mt-2">past</span>
                                    :null}
                                </div>
                                <div className = "mt-2">
                                    <input id = {`acknowledge ${i} 2`} className = "cssCheckBox mt-2" type = "checkbox" disabled = {!(isEdittingContent && (timeValid2(week, i)) || form.form[i].unlock)} 
                                    checked = {form.form[i].afternoon} onChange = {e => {
                                        setForms(week, {
                                            ...form, 
                                            form: form.form.map(
                                                (
                                                    (ff, weekday) => weekday === i?
                                                    {
                                                        ...ff, 
                                                        afternoon: e.currentTarget.checked
                                                    }:ff
                                                )
                                            )
                                        });
                                    }}/><label htmlFor = {`acknowledge ${i} 2`} className = "d-inline mb-0 ml-2">I acknowledge that I understand the dangers of high temperatures and that I am currently safe.</label>
                                </div>
                                <div className = "mt-2">
                                    <label htmlFor = {`ot ${i}`} className = "font-weight-bold mb-0">Are you planning to do OT?</label>
                                    {isEdittingContent && (timeValid2(week, i) || form.form[i].unlock)?
                                        <select id = {`ot ${i}`} className = "form-control"
                                            value = {form.form[i].doOT}
                                            onChange = {e => {
                                                const value = e.currentTarget.value;
                                                setForms(week, {
                                                    ...form, 
                                                    form: form.form.map(
                                                        (
                                                            (ff, weekday) => weekday === i?
                                                            ({
                                                                ...ff, 
                                                                doOT: value, 
                                                                otDate: "", 
                                                                otTime: ""
                                                            }):ff
                                                        )
                                                    )
                                                });
                                            }}
                                        >
                                            <option value = "">Select</option>
                                            <option>Yes</option>
                                            <option>No</option>
                                        </select>
                                        :
                                        <span className = "ml-2">
                                            {form.form[i].doOT}
                                        </span>
                                    }
                                </div>
                                {form.form[i].doOT === "Yes"?
                                <>
                                    <label htmlFor = {`endDate ${i}`} className = "font-weight-bold mb-0 mt-2">Estimated End Date</label>
                                    {isEdittingContent && (timeValid2(week, i) || form.form[i].unlock)?
                                    <input className = "form-control"
                                        id = {`endDate ${i}`}
                                        required
                                        type = "date"
                                        value = {form.form[i].otDate}
                                        onChange = {e => {
                                            setForms(week, {
                                                ...form, 
                                                form: form.form.map(
                                                    (
                                                        (ff, weekday) => weekday === i?
                                                        ({
                                                            ...ff, 
                                                            otDate: e.currentTarget.value
                                                        }):ff
                                                    )
                                                )
                                            });
                                        }}
                                    />
                                    :
                                    <span className = "ml-2">
                                        {form.form[i].otDate}
                                    </span>
                                    }
                                    <label htmlFor = {`endTime ${i}`} className = "font-weight-bold mb-0 mt-2">Estimated End Time</label>
                                    {isEdittingContent && (timeValid2(week, i) || form.form[i].unlock)?
                                    <input className = "form-control"
                                        id = {`endTime ${i}`}
                                        required
                                        type = "time"
                                        value = {form.form[i].otTime}
                                        onChange = {e => {
                                            setForms(week, {
                                                ...form, 
                                                form: form.form.map(
                                                    (
                                                        (ff, weekday) => weekday === i?
                                                        ({
                                                            ...ff, 
                                                            otTime: e.currentTarget.value
                                                        }):ff
                                                    )
                                                )
                                            });
                                        }}
                                    />
                                    :
                                    <span className = "ml-2">
                                        {form.form[i].otTime}
                                    </span>
                                    }
                                </>:<></>}
                            </div>)}
                        </div>
                        {new Date(getDateEndFromWeekNum2(week)) >= new Date()?
                        <div className = "mt-2 text-right">
                            {isEdittingContent?
                            <button
                                type = "submit"
                                value = "Submit"
                                className = "btn btn-info"
                            >
                                Save Content
                            </button>:
                            <span className = "btn btn-info"
                                onClick = {() => {
                                    setIsEdittingContent(true);
                                    setUpdateDateTime({...updateDateTime, "Forms": getTimeStamp()});
                                }}
                            >
                                Edit Content
                            </span>
                            }
                        </div>
                        :<></>}
                    </form>}
                </div>
            </div>
        </div>
    )
}